const baseURL = process.env.NODE_ENV==='production'? 'https://api.prevention-risquespro.fr':"http://localhost:4000"
 
/*!

 =========================================================
 * Vue Light Bootstrap Dashboard - v2.0.0 (Bootstrap 4)
 =========================================================

 * Product Page: http://www.creative-tim.com/product/light-bootstrap-dashboard
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

// https://vueformulate.com/guide/installation/#npm
import VueFormulate from '@braid/vue-formulate'

// https://www.codeandweb.com/babeledit/tutorials/how-to-translate-your-vue-app-with-vue-i18n
import { fr } from '@braid/vue-formulate-i18n'

// LightBootstrap plugin
import LightBootstrap from './light-bootstrap-main'

// router setup
import routes from './routes/routes'

import axios from "axios";

import './registerServiceWorker'
import UserManager from './usermanager.js'

import { BootstrapVue, IconsPlugin, BTable, BTableSimple, TablePlugin  } from 'bootstrap-vue'
// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// https://vueformulate.com/guide/theming/#default-theme
import './assets/css/snow.css';

import VueFormulateDatepickerPlugin from "vue-formulate-datepicker";

// Add styles if need
import "./assets/css/Datepicker.css";

// plugin setup 
Vue.use(VueRouter)
Vue.use(LightBootstrap)

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)

// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

// Vue.use(BTable)
// Vue.use(BTableSimple)
Vue.use(TablePlugin)


import CheckboxTable from './components/Forms/CheckboxTable.vue'
import FormImage from './components/Forms/FormImage.vue'
import LabelEditable from './components/Forms/LabelEditable.vue'
import AutoComplete from './components/Forms/AutoComplete.vue'

import Business from 'ppe-business'


// register your component with Vue
Vue.component('CheckboxTable', CheckboxTable)
Vue.component('FormImage', FormImage)
Vue.component('LabelEditable', LabelEditable)
Vue.component('AutoComplete', AutoComplete)

const base = axios.create({
  baseURL: baseURL,
  timeout: 10000,
})

base.baseURL = baseURL

const axiosUploader = axios.create( {
  baseURL: baseURL ,
  timeout: 60000,
  headers: {'Content-Type': 'multipart/form-data'}
})


Vue.use(VueFormulate,  {
  uploader : axiosUploader, 
  uploadUrl : "/form/upload",
  fileUrlKey: "url",
  
  plugins: [ fr, VueFormulateDatepickerPlugin ],
  locale: 'fr',
  rules: {
    checkCodeValidity : ({ code }) => /^[a-zA-Z0-9_-]*$/.test(code) ,
    
  },
  library : {
    checkboxtable: {
      classification:'',
      component:'CheckboxTable'
    },

    FormImage: {
      classification: 'text',
      component: 'FormImage',
      slotProps: {
        component: ['url']
      }
    }
  }
})



/*const config = {
  headers: {
      "Content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem("jwt")}`,
  },
};    */

//base.defaults.headers.common['content-type'] = 'application/json';
base.interceptors.request.use(
  config => {
    // Set Authorization before request is sent
    config.headers["Authorization"] = "Bearer " + localStorage.getItem("jwt");
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

Vue.prototype.$features = {
  labelEditMode : false, // Allow to edit text inline
}

Vue.prototype.$http = base
Vue.prototype.$usermanager = UserManager
// Create an event bus si that component can send emit to anyone in the app
Vue.prototype.$eventbus = new Vue()

Vue.prototype.$t = function(resourceId, defaultTo, params) {
  return Business.R(resourceId, defaultTo, params, Vue.prototype.$features.labelEditMode)
}

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'nav-item active',
  
  // https://stackoverflow.com/questions/34623833/vue-js-how-to-remove-hashbang-from-url
  mode: 'history', // remove # from url

  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.afterEach( async (to, from) => {
  // Manage to refresh the page if the server version has changed
  
  if(!Vue.prototype.$version) {
    Vue.prototype.$version = Business.ClientVersion
  }

  let res = await base.get('/version/')

  //console.log("router.afterEach:version", res.data.version, Vue.prototype.$version)
  
  if( Vue.prototype.$version !== res.data.version ) {
    window.location.reload()
    Vue.prototype.$version = res.data.version
    console.log("router.afterEach:version RELOADED")
  }  
  //console.log("router.afterEach:version", res.data.version, Vue.prototype.$version)
})

// Check if the route needs authentication or not
router.beforeEach((to, from, next) => {
  
  console.log("before routing", to.name)

  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (UserManager.isUserLoggedIn()) {
    
      if(to.matched.some(record => record.meta.requiresAdmin)) {
        if (UserManager.isAdmin()) {
        
          //console.log("ADMIN", UserManager.user)
          next()
          return
        } else {
          console.error("Requires Admin authorization", to.name )
          swal("Erreur", "Vous devez avoir les aurorisations admin", "error");
          next('/login')
        }
        
      }

      //console.log("USER", UserManager.user)
      next()
      return
    } else {
      swal("Erreur", "Vous devez être identifié", "error");
      console.error("Requires authentication", to.path )
      window.location='/login?redirectUrl='+to.path
    }
    
  } else {
    next()
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router
})

